import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { DataAssetCaptureComponent } from './data-asset-capture.component';

import {
  DataAssetCaptureCreateOrUpdateComponent
} from './data-asset-capture-create-or-update/data-asset-capture-create-or-update.component';

import {
  DataAssetCaptureFileCreateOrUpdateComponent
} from './data-asset-capture-file-create-or-update/data-asset-capture-file-create-or-update.component';

import {
  DataAssetManualCreateOrUpdateComponent
} from './data-asset-manual-create-or-update/data-asset-manual-create-or-update.component';

const routes: Routes = [
  {
    path: '',
    component: DataAssetCaptureComponent
  },
  {
    path: 'create',
    component: DataAssetCaptureCreateOrUpdateComponent,
    data: { create: true }
  },
  {
    path: 'update/:assetsourceId',
    component: DataAssetCaptureCreateOrUpdateComponent,
    data: { create: false }
  },
  {
    path: 'file/create',
    component: DataAssetCaptureFileCreateOrUpdateComponent,
    data: { create: true }
  },
  {
    path: 'file/update/:assetsourceId',
    component: DataAssetCaptureFileCreateOrUpdateComponent,
    data: { create: false }
  },
  {
    path: 'create-asset',
    component: DataAssetManualCreateOrUpdateComponent,
    data: { create: true }
  },
  {
    path: 'update-asset/:assetId',
    component: DataAssetManualCreateOrUpdateComponent,
    data: { create: false }
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ]
})
export class DataAssetCaptureRouter {}